<template>
  <div class="truck-crew">
    <p class="hint">
      ໂຊເຟີ້ປະຈຳລົດ <b>{{ truck.plate_number }}</b> — ຄົນທຳອິດ = ຄົນຂັບຫຼັກ.
      ເມື່ອເລືອກລົດຄັນນີ້ໃສ່ຖ້ຽວທີ່ຍັງບໍ່ມີຄົນຂັບ ລະບົບຈະໃສ່ໂຊເຟີ້ເຫຼົ່ານີ້ໃຫ້ອັດຕະໂນມັດ.
    </p>
    <multiselect
        v-model="selected"
        :options="driverOptions"
        :multiple="true"
        :close-on-select="false"
        label="pickerLabel"
        track-by="id"
        placeholder="ຄົ້ນຫາ ແລະ ເລືອກໂຊເຟີ້ (ຊື່ / ເບີ / ລະຫັດ)..."
        :loading="driverOptionsLoading"
    >
    </multiselect>
    <div class="actions-row">
      <vs-button :loading="saving" :disabled="driverOptionsLoading" @click="Save()">
        <i class="fal fa-save"></i>&nbsp;ບັນທຶກ
      </vs-button>
    </div>
  </div>
</template>

<script>
import MixinFleetTrucks from '@/Mixins/Fleet/Trucks';

/** Edit one truck's default crew (ໂຊເຟີ້ປະຈຳລົດ), primary first. */
export default {
  mixins: [MixinFleetTrucks],
  props: {
    truck: {type: Object, required: true},
  },
  data: () => ({
    selected: [],
    saving: false,
  }),
  methods: {
    Save() {
      // Never save before the current crew is on screen — an empty selection
      // would clear the truck's default crew.
      if (this.driverOptionsLoading) return;
      this.saving = true;
      this.SetTruckDefaultDrivers(this.truck.id, this.selected.map((d) => d.id)).then(() => {
        this.saving = false;
        this.$emit('success');
        this.$emit('close');
      }).catch(() => {
        this.saving = false;
      });
    },
  },
  created() {
    // The current crew is shown immediately (from the truck row), so a slow
    // driver list can never leave an empty selection that Save would persist.
    const current = this.truck.default_drivers || [];
    const fallback = (d) => ({
      id: d.driver_id,
      pickerLabel: `${d.driver_name || '#' + d.driver_id}${d.driver_card_id ? ' · ລະຫັດ ' + d.driver_card_id : ''}`,
    });
    this.selected = current.map(fallback);
    this.driverOptionsLoading = true;
    this.FetchDriverOptions().then(() => {
      // Swap in the option objects (same ids) so the picker shows them selected.
      this.selected = this.selected.map((s) => this.driverOptions.find((o) => o.id === s.id) || s);
    });
  },
};
</script>

<style scoped>
.truck-crew {
  min-width: 520px;
}

.hint {
  font-size: 13px;
  color: #555;
  margin-bottom: 10px;
}

.actions-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
</style>
